import React, { useState } from 'react';
import { VideoErrorBoundary } from '../VideoErrorBoundary/VideoErrorBoundary';
import ShareFeedbackDialog from '../../features/shareFeedbackDialog/ShareFeedbackDialog';

interface IProps {
  children: React.ReactNode;
  fallbackTitle?: string;
  fallbackMessage?: string;
  onRetry?: () => void;
}

const VideoErrorBoundaryWithFeedback: React.FC<IProps> = ({
  children,
  fallbackTitle,
  fallbackMessage,
  onRetry,
}) => {
  const [showFeedbackDialog, setShowFeedbackDialog] = useState(false);

  const handleReportIssue = () => {
    setShowFeedbackDialog(true);
  };

  const handleCloseFeedback = () => {
    setShowFeedbackDialog(false);
  };

  return (
    <>
      <VideoErrorBoundary
        fallbackTitle={fallbackTitle}
        fallbackMessage={fallbackMessage}
        onRetry={onRetry}
        reportIssue={handleReportIssue}
      >
        {children}
      </VideoErrorBoundary>

      <ShareFeedbackDialog
        isOpen={showFeedbackDialog}
        handleClose={handleCloseFeedback}
      />
    </>
  );
};

export default VideoErrorBoundaryWithFeedback;
